import {
    GET_PRIZEPOOL_DETAIL_REQUEST,
    GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE,
    GET_PRIZEPOOL_REQUEST,
    GET_PRIZEPOOL_REQUEST_SUCCESS,
    GET_PRIZEPOOL_REQUEST_FAILURE,

} from "../constants";

const initialState = {
    loader: false,
    games: [],
    gameDetail: {}
};

export default function PrizePoolReducer(state = initialState, action) {
    switch (action.type) {
        case GET_PRIZEPOOL_REQUEST:
            state = {
                ...state,
                loader: true,
            };
            break;
        case GET_PRIZEPOOL_REQUEST_SUCCESS:
            state = {
                ...state,
                games: action.payload,
                loader: false,
            };
            break;
        case GET_PRIZEPOOL_REQUEST_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        case GET_PRIZEPOOL_DETAIL_REQUEST:
            state = {
                ...state,
                loader: true,
            };
            break;
        case GET_PRIZEPOOL_DETAIL_REQUEST_SUCCESS:
            state = {
                ...state,
                gameDetail: action.payload,
                loader: false,
            };
            break;
        case GET_PRIZEPOOL_DETAIL_REQUEST_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;

        default:
            break;
    }

    return state;
}
